// export const changeFormatOfDate = (pDate) => {
//   let currentDate = new Date(pDate);

//   let day = currentDate.getDate();
//   let month = currentDate.getMonth() + 1;
//   let year = currentDate.getFullYear();

//   let hours = currentDate.getHours();
//   let minutes = currentDate.getMinutes();

//   return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes;
// };

export const changeFormatOfDate = (pDate: string | number | Date | null | undefined) => {
  let currentDate = pDate == null ? new Date(NaN) : new Date(pDate);

  let day = ('0' + currentDate.getDate()).slice(-2);
  let month = ('0' + (currentDate.getMonth() + 1)).slice(-2);
  let year = currentDate.getFullYear();

  let hours = ('0' + currentDate.getHours()).slice(-2);
  let minutes = ('0' + currentDate.getMinutes()).slice(-2);

  return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes;
};
